import React, { useState } from 'react';
import { format, differenceInCalendarDays } from 'date-fns';
import { es } from 'date-fns/locale';
import { Sparkles, X } from 'lucide-react';
import { usePerfil } from '../../context/PerfilContext';
import { usePlus } from '../../context/PlusContext';
import { DIAS_AVISO_FIN_REGALO } from '../../config/planes';
import { NOMBRE_APP } from '../../config/marca';

const CLAVE = 'rzcentral.avisoFinRegalo';

/**
 * Un mes antes de que acabe el Plus regalado a los primeros usuarios, aviso
 * con la oferta. Se puede cerrar, y vuelve una vez más en la última semana.
 */
export const AvisoFinRegalo: React.FC = () => {
  const { estadoPlus } = usePerfil();
  const { ofrecerPlus } = usePlus();
  const [cerrado, setCerrado] = useState(() => {
    try { return localStorage.getItem(CLAVE) ?? ''; } catch { return ''; }
  });

  if (estadoPlus.motivo !== 'regalo' || !estadoPlus.hasta) return null;
  const quedan = differenceInCalendarDays(estadoPlus.hasta, new Date());
  if (quedan > DIAS_AVISO_FIN_REGALO) return null;
  // Una marca por aviso: el del mes y el de la última semana
  const fase = `${estadoPlus.hasta.toISOString()}|${quedan <= 7 ? 'semana' : 'mes'}`;
  if (cerrado === fase) return null;

  const cerrar = () => {
    try { localStorage.setItem(CLAVE, fase); } catch { /* sin almacenamiento: solo por esta vez */ }
    setCerrado(fase);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 pt-4">
      <div role="status" className="flex gap-3 rounded-xl border border-amber-200 dark:border-amber-700
                      bg-amber-50 dark:bg-amber-900/20 px-4 py-3">
        <Sparkles className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">
            {quedan <= 0 ? 'Tu Plus de regalo acaba hoy' : `Te quedan ${quedan} ${quedan === 1 ? 'día' : 'días'} de Plus gratis`}
          </p>
          <p className="text-xs text-amber-800 dark:text-amber-300 mt-0.5">
            Por ser de los primeros, tienes {NOMBRE_APP} Plus hasta el{' '}
            {format(estadoPlus.hasta, "d 'de' MMMM", { locale: es })}. Después no se borra nada,
            pero vuelven los límites del plan gratis.
          </p>
          <button type="button" onClick={() => ofrecerPlus()}
            className="mt-2 text-xs font-semibold px-3 py-2 rounded-lg bg-amber-600 hover:bg-amber-700 text-white transition">
            Ver {NOMBRE_APP} Plus
          </button>
        </div>
        <button type="button" onClick={cerrar} aria-label="Cerrar aviso"
          className="self-start p-1 text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/40 rounded">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
